import "../../styles/ui_components/_accordion.scss"

import { isHandheld } from "../../helpers/window_size"

const ACCORDION_SELECTOR = ".ui-component-accordion"
const ITEM_SELECTOR = ".accordion-item"
const ACTIVE_CLASS = "active"
const READY_ATTR = "data-ready"

const setActiveItem = function(this : HTMLElement, e : Event) : void {
  const clickTarget =
    e.target && (e.target as HTMLElement).closest(`${ITEM_SELECTOR} > :first-child`)
  const selectedItem = clickTarget && (clickTarget.parentNode as HTMLElement)
  if (!clickTarget || !selectedItem) return

  if ("autoCollapse" in this.dataset) {
    const activeItem = this.querySelector(`${ITEM_SELECTOR}.${ACTIVE_CLASS}`)
    const activeIsNotSelected = activeItem !== selectedItem

    if (activeItem && activeIsNotSelected) {
      activeItem.classList.remove(ACTIVE_CLASS)
      if (isHandheld()) selectedItem.scrollIntoView()
    }
  }

  selectedItem.classList.toggle(ACTIVE_CLASS)

  if ("toggleOnce" in this.dataset) {
    selectedItem.firstElementChild?.remove()
    this.removeEventListener("click", setActiveItem)
  }
}

const setupAccordions = (accordions: NodeListOf<HTMLElement>): void => {
  for (const accordion of accordions) {
    if (accordion.hasAttribute(READY_ATTR)) continue

    accordion.addEventListener("click", setActiveItem)
    accordion.setAttribute(READY_ATTR, "")
  }
}

const mutationObserver = new MutationObserver((mutations) : void => {
  mutations.forEach((mutation) : void => {
    if (mutation.type !== "childList") return

    setupAccordions(document.querySelectorAll(ACCORDION_SELECTOR))
  })
})

export const openAccordionsIn = (container : HTMLElement | Document) : void => {
  container.querySelectorAll(ITEM_SELECTOR).forEach(item => {
    item.classList.toggle(ACTIVE_CLASS, true)
  })
}

mutationObserver.observe(document.body, { subtree: true, childList: true })
setupAccordions(document.querySelectorAll(ACCORDION_SELECTOR))
